/**
 * How an account's delivery date is decided at checkout (Suppliers.delivery_mode). Mirrors the API enum.
 *
 * - FIXED_ROUTE: Delivery Deadlines schedules; each customer is assigned route days and the next delivery
 *   date is derived from the hard deadlines. The customer never picks.
 * - CUSTOMER_SELECTS: the customer picks the date per order under the account's daily cutoff time, lead
 *   time (days) and blocked days of week (OR-1531).
 */
enum DeliveryModeEnum {
    FIXED_ROUTE = "fixed_route",
    CUSTOMER_SELECTS = "customer_selects",
}

export default DeliveryModeEnum;
